import React, { useState, useRef, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, Notification, TextInput, DatePickerInput, Button, DataTable, Filter, Modal, Icon, Link, Tag, Slot, Font, Divider, Pagination } from "pepsico-ds";
import "./extension_reactivation.css";
import arReactivateService from "../../services/arReactivateService";
import { toast, ToastContainer } from "react-toastify";
import { set } from "date-fns";
import { useTranslation } from "react-i18next";



const BulkRevalidation = () => {
    const [expireDate, setExpireDate] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [copyButtonText, setCopyButtonText] = useState("Copy");
    const [selectedRows, setSelectedRows] = useState([]);
    const navigate = useNavigate();
    const [reactivatedData, setReactivatedData] = useState([]);
    const [selectedAllRows, setAllRowData] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [requestData, setRequestData] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [userGpId, setUserGpId] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false);
    const [direction, setSelectedDirection] = useState(null);
    const [disbaleSubmit, setDisbaleSubmit] = useState(false);
    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const { t, i18n } = useTranslation();
    const pageSize = 10;
    
    // Get current page data
    const currentPageData = reactivatedData.slice(
        currentPageIndex * pageSize,
        (currentPageIndex + 1) * pageSize
    );
    const totalPages = Math.ceil(reactivatedData.length / pageSize);

    const columns = [
        {
            columnKey: 'gpid',
            header: t('nonArExtension.global_id'),
            initialSize: 150,
        },
        {
            columnKey: 'fullName',
            header: t('nonArExtension.column_full_name'),
            initialSize: 240,
        },
        {
            columnKey: 'category',
            header: t('nonArExtension.column_category'),
            initialSize: 180,
        },
        {
            columnKey: 'status',
            header: t('nonArExtension.column_status'),
            initialSize: 120
        },
        {
            columnKey: 'company',
            header: t('nonArExtension.column_company'),
            initialSize: 180,
        },
        {
            columnKey: 'expiration',
            header: t('nonArExtension.column_expiration_date'),
            initialSize: 140,
        },

        // {
        //     columnKey: 'expired_date',
        //     header: 'EXPIRED DATE',
        //     initialSize: 220
        // },
        {
            columnKey: 'password_change_date',
            header: t('nonArExtension.column_password_change_date'),
            initialSize: 180,
        },
        {
            columnKey: 'password_expired',
            header: t('nonArExtension.column_password_expired'),
            initialSize: 140,
        },
        {
            columnKey: 'delagated_manager',
            header: t('nonArExtension.column_delegated_manager'),
            initialSize: 180,
        },
        {
            columnKey: 'emailAddress',
            header: t('nonArExtension.column_email_address'),
            initialSize: 180,
        },

    ];

    const onClickToFilterExpiration = (value) => {
        let filteredDate = [];
        setSelectedDirection(value);
        
        const filterDate = new Date(selectedDate);
        filterDate.setHours(0, 0, 0, 0);
        
        if (value === t('nonArExtension.after_lower')) {
            filteredDate = selectedAllRows?.filter((item) => {
                if (!item.expiration || item.expiration === "-") return false;
                const itemDate = new Date(item.expiration);
                if (isNaN(itemDate.getTime())) return false;
                itemDate.setHours(0, 0, 0, 0);
                return itemDate >= filterDate;
            });
        } else if (value === t('nonArExtension.before_lower')) {
            filteredDate = selectedAllRows?.filter((item) => {
                if (!item.expiration || item.expiration === "-") return false;
                const itemDate = new Date(item.expiration);
                if (isNaN(itemDate.getTime())) return false;
                itemDate.setHours(0, 0, 0, 0);
                return itemDate <= filterDate;
            });
        }
        setCurrentPageIndex(0);
        // Keep only selections that are still in filtered data
        const filteredGpids = filteredDate.map(row => row.gpid);
        setSelectedRows(prev => prev.filter(row => {
            const gpid = row.original ? row.original.gpid : row.gpid;
            return filteredGpids.includes(gpid);
        }));
        setReactivatedData(filteredDate);
    }

    // Auto-filter when date is selected (default to "after" filter)
    useEffect(() => {
        if (selectedDate && selectedAllRows?.length > 0) {
            const filterDate = new Date(selectedDate);
            filterDate.setHours(0, 0, 0, 0);
            
            // Default to "after" filter when date is selected
            const filteredData = selectedAllRows.filter((item) => {
                if (!item.expiration || item.expiration === "-") return false;
                const itemDate = new Date(item.expiration);
                if (isNaN(itemDate.getTime())) return false;
                itemDate.setHours(0, 0, 0, 0);
                return itemDate >= filterDate;
            });
            
            setSelectedDirection(t('nonArExtension.after_lower'));
            setCurrentPageIndex(0);
            // Keep only selections that are still in filtered data
            const filteredGpids = filteredData.map(row => row.gpid);
            setSelectedRows(prev => prev.filter(row => {
                const gpid = row.original ? row.original.gpid : row.gpid;
                return filteredGpids.includes(gpid);
            }));
            setReactivatedData(filteredData);
        }
    }, [selectedDate]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        const data = JSON.parse(localStorage.getItem("okta-token-storage"));
        if (data?.accessToken?.claims?.gpid) {
            setUserGpId(data?.accessToken?.claims?.gpid);
        }
        fetchUserData();
        return () => window.removeEventListener('resize', handleResize);

    }, [userGpId]);

    function formatPepPwdChangeDate(value) {
        if (!value) return "N/A";

        const cleanValue = value.trim().replace("Z", "");

        const year = cleanValue.slice(0, 4);
        const month = cleanValue.slice(4, 6);
        const day = cleanValue.slice(6, 8);

        return `${year}-${month}-${day}`;
    }

    function parsePepPwdChangeTime(value) {
        if (!value) return null;

        const cleanValue = value.trim().replace("Z", "");
        const year = cleanValue.slice(0, 4);
        const month = cleanValue.slice(4, 6);
        const day = cleanValue.slice(6, 8);
        const hour = cleanValue.slice(8, 10);
        const minute = cleanValue.slice(10, 12);
        const second = cleanValue.slice(12, 14);

        return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);
    }

    function isPasswordExpiredFromPep(value) {
        const parsedDate = parsePepPwdChangeTime(value);
        if (!parsedDate || isNaN(parsedDate)) return "N/A";

        const expiryDate = new Date(parsedDate);
        expiryDate.setDate(expiryDate.getDate() + 90);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expiryDate.setHours(0, 0, 0, 0);

        return today > expiryDate ? "Yes" : "No";
    }

    const fetchUserData = async () => {
        setLoading(true);
        setError(null);
        try {
            if (!userGpId) {
                setError(t('nonArExtension.gpid_missing_error'));
                setLoading(false);
                return;
            }
            const userId = { "gpid": userGpId }
            const response = await arReactivateService.getReactivatedBulkUser(userId);
            const allRows = Object.entries(response.data.mapOfRevalidationReactivateResponse).map(([gpid, user]) => ({
                gpid: gpid.trim(),
                fullName: user.pepDisplayedFirstName ? `${user.pepDisplayedFirstName || ""} ${user.pepDisplayedLastName || ""}` : "-",
                category: user.pepUserCategory || "",
                status: user.pepUserStatus,
                expiration: user.pepRevalidationDate || "-",
                password_change_date: formatPepPwdChangeDate(user.pepPwdChangeTime),
                password_expired: isPasswordExpiredFromPep(user.pepPwdChangeTime),
                delegated_manager: user.pepDelegatedManager || "N/A",
                emailAddress: user.mail || "N/A",
                expired_date: user.pepEffectiveDate
            }));
            setAllRowData(allRows);
            const transformedData = Object.entries(response.data.mapOfRevalidationReactivateResponse).map(([gpid, user]) => ({
                gpid: gpid.trim(),
                fullName: user.pepDisplayedFirstName ? `${user.pepDisplayedFirstName || ""} ${user.pepDisplayedLastName || ""}` : "-",
                category: user.pepUserCategory || "",
                status: user.pepUserStatus,
                expiration: user.pepRevalidationDate || "-",
                // expired_date: user.pepEffectiveDate,
                password_change_date: formatPepPwdChangeDate(user.pepPwdChangeTime),
                password_expired: isPasswordExpiredFromPep(user.pepPwdChangeTime),
                delegated_manager: user.pepDelegatedManager || "N/A",
                emailAddress: user.mail || "N/A",
                company: user.pepCompany || ""
            }));

            setReactivatedData(transformedData);
        } catch (err) {
            setError(err.message || t('nonArExtension.error_api_message'));
        } finally {
            setLoading(false);
        }
    };

    const onClickRevalidate = () => {
        const expiredPwdUsers = selectedRows.filter(item => {
            const status = item.original.password_expired;
            return status && status.toLowerCase() === "yes";
        });
        if (selectedRows.length > 50) {
            toast.error("You can select a maximum of 50 records");
            return;
        }
        if (expiredPwdUsers.length > 0) {
            setShowWarningModal(true);
        } else {
            // setShowModal(true);
            onClickSubmit();
        }
    }

    const onClickSubmit = async () => {
        setIsSubmitting(true);
        setDisbaleSubmit(true)
        const gpids = selectedRows.map(item => item.original.gpid);
        console.log("selectedRows::::::::::", selectedRows);
        const data = {
            listGpidForUpdate: gpids
        };
        console.log("data::::::::::", data);
        try {
            const response = await arReactivateService.updateBulkReactivatedUser(data);
            if (response.status == 200) {
                if (response.data.status == "Failed") {
                    toast.error(response.data.errorMessage);
                    setIsSubmitting(false);
                    setDisbaleSubmit(false);
                    setShowModal(false);
                    setShowWarningModal(false);
                    return;
                }
                setRequestData(response.data);
                setIsSubmitting(false);
                setDisbaleSubmit(false);
                setIsSuccess(true);
                setShowModal(false);
                setShowWarningModal(false);
                setSelectedRows([]);
                fetchUserData();

            } else {
                toast.error(t('nonArExtension.error_api'));
                setIsSubmitting(false);
                setDisbaleSubmit(false);
                setShowModal(false);
                setShowWarningModal(false);
                return;
            }
        } catch (error) {
            toast.error(t('nonArExtension.column_error_api'));
            setIsSubmitting(false);
            setDisbaleSubmit(false);
            setShowModal(false);
            setShowWarningModal(false);
        }
    };


    const onRowSelectionChange = (newSelection) => {
        console.log("newSelection:", newSelection);
        
        // Get gpids of the current page
        const currentPageGpids = currentPageData.map(row => row.gpid);
        
        // Keep selections from other pages (not on current page)
        const otherPageSelections = selectedRows.filter(row => {
            const gpid = row.original ? row.original.gpid : row.gpid;
            return !currentPageGpids.includes(gpid);
        });
        
        // Combine: other pages + current page new selections
        const combined = [...otherPageSelections, ...newSelection];
        
        if(combined.length > 50){
            if(!disbaleSubmit) setDisbaleSubmit(true);
            toast.error(t("nonArExtension.row_select_limit_message"));
            return;
        }
        if(disbaleSubmit) setDisbaleSubmit(false);
        setSelectedRows(combined);
    }

    const closeModal = () => {
        setShowModal(false);
    }
    const closeWarningModal = () => {
        setShowWarningModal(false);
    }

    const onClickCopynumber = () => {
        setCopyButtonText("Copied");
    }

    const getGpidList = () => {
        const gpids = selectedRows.flat().map(row => row.original.gpid).join(", ");
        return gpids;
    }

    const getPwdExpiredGpidList = () => {
        const expiredGpids = selectedRows
            .flat()
            .filter(row => {
                const status = row.original.password_expired;
                return status && status.toLowerCase() === "yes";
            })
            .map(row => row.original.gpid);

        return expiredGpids.join(", ");
    };


    const onClickCancel = () => {
        navigate(-1);
    }

    const renderWarningConfirmModal = () => {
        return (
            <div className="confirm-modal">
                <Modal
                    showModal={showWarningModal}
                    className="reactivation-warning-modal"
                    onCloseModal={closeWarningModal}
                    closeOnOutsideClick = {false}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showPrimaryButton={true}
                    showSecondaryButton={true}
                    showSlot
                    showTertiaryButton={false}
                    showCloseButton={true}
                    style={{}}
                    text={<>{t('nonArExtension.password_policy_msg')}<br></br>
                        {/* <div style={{ marginTop: '10px' }}>{getGpidList()}</div> */}
                        <br></br>
                    </>}
                    title={t('nonArExtension.warning')}
                    type="fluid"
                    viewPort="desktop"
                     primaryButtonProps={{
                        onClick: onClickSubmit,
                        size: 'medium',
                        text: t('nonArExtension.submit'),
                        variant: 'primary',
                        className: "warning-modal-submit-button",
                        disabled: disbaleSubmit
                    }}
                    secondaryButtonProps={{
                        onClick: closeWarningModal,
                        size: 'medium',
                        text: t('nonArExtension.cancel'),
                        variant: 'secondary',
                        className: "warning-modal-cancel-button",
                        disabled: disbaleSubmit
                    }}
                >
                    <div className="gpid-list-container pt-0">
                        {getPwdExpiredGpidList()}
                    </div>
                    {/* <div className="confirm-modal-btn">
                        <button className="extension-cancel-button" onClick={closeWarningModal} >
                            {t('nonArExtension.cancel')}
                        </button>

                    </div> */}
                </Modal>
            </div>
        )
    }

    const renderConfirmModal = () => {
        return (
            <div className="confirm-modal">
                <Modal
                    showModal={showModal}
                    className=""
                    onCloseModal={closeModal}
                    closeOnOutsideClick = {false}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showPrimaryButton={false}
                    showSecondaryButton={false}
                    showSlot
                    showTertiaryButton={false}
                    showCloseButton={true}
                    style={{}}
                    text={<>{t('nonArExtension.confirmation_msg')}<br></br>
                        {/* <div style={{ marginTop: '10px' }}>{getGpidList()}</div> */}
                        <br></br>
                    </>}
                    title="Confirm Selection"
                    type="fluid"
                    viewPort="desktop"
                >
                    <div className="gpid-list-container">
                        {getGpidList()}
                    </div>
                    <div className="confirm-modal-btn">
                        <button className="extension-cancel-button" onClick={closeModal} >
                            {t('nonArExtension.cancel')}
                        </button>
                        <Button
                            className=""
                            size="medium"
                            style={{}}
                            text={isSubmitting ? t('nonArExtension.submitting') : t('nonArExtension.submit')}
                            variant="primary"
                            onClick={onClickSubmit}
                        />

                    </div>
                </Modal>
            </div>
        )
    }

    const backToDashboard = () => {
        return (
            <>
                <div className="dashboard-btn" onClick={onClickToGoBack}><Icon
                    alt="alt value"
                    icon="arrow_back"
                    size="medium"
                    style={{ marginRight: '8px' }}
                />{t('nonArExtension.back_to_dashboard')}</div>
            </>
        )
    }

    const onClickToGoBack = () => {
        navigate(-1);
    }
    const renderErrorMesg = () => {
        return (
            <>
                <Icon
                    alt="alt value"
                    icon="mobiledata_off"
                    size="large"
                    style={{}}
                />
                <span className="error-title">{t('nonArExtension.error_no_data_title')}</span>
            </>
        )
    }

    const onClickToClearFilters = () => {
        setSelectedDirection(null);
        setSelectedDate(null);
        setCurrentPageIndex(0);
        // Reset to all data (already fetched)
        setReactivatedData(selectedAllRows);
    }

    useEffect(() => {
        if (isSuccess) {
            const timer = setTimeout(() => {
                setIsSuccess(false);
                navigate("/home");
            }, 4000);

            return () => clearTimeout(timer);
        }
    }, [isSuccess]);

    return (
        <>
            {(loading) && (<div>{t('nonArExtension.regular_loading')}</div>)}
            <div className="extension-container">
                {(isSuccess) && (
                    <Notification
                        className="bulk-notification"
                        showIcon
                        showText
                        showTitle={false}
                        style={{ marginBottom: "20px" }}
                        text={t('nonArExtension.success_msg')}
                        // title="Title"
                        type="success"
                    />
                )}
                {(isMobile) ? backToDashboard() : (
                    <Breadcrumb
                        homeIcon={{
                            icon: "home",
                            onClick:()=>{
                            navigate("/home")
                            }
                        }}
                        breadcrumbs={[
                            {
                                label: t('nonArExtension.home')
                            },
                            {
                                label: <div onClick={()=>{
                                    navigate("/myidmPortal")
                                }}>{ t('nonArExtension.myidm')}</div>
                            },
                            {
                                label: <div onClick={()=>{
                                    navigate("/myidmPortal")
                                }}>{ t('nonArExtension.manager_acc_title')}</div>
                            },
                            {
                                label: t('nonArExtension.bulk_revalidation')
                            }
                        ]}
                        className=""
                        style={{}}
                    />
                )}
                <h4 className="extension-page-title" style={{ marginTop: !isMobile ? "32px" : "0px" }}>{t('nonArExtension.bulk_revalidation_for_non_employee')}</h4>
                {!loading && !error && reactivatedData && reactivatedData.length > 0  ? <div className="bulk-save-container row" style={{ marginTop: '20px' }}>
                    <div className="extension-edit-status col-md-6 col-12">
                        <span className="extension-edit-mode-text">{t('nonArExtension.expiration_date_update')}</span>
                        <span style={{ fontSize: 14, color: "#616161" }}>
                            {t('nonArExtension.this_action_will_revalidate', { count: selectedRows.length })}
                        </span>
                    </div>

                    <div className="extension-edit-actions col-md-6 col-12">
                        <button className="extension-cancel-button" onClick={onClickCancel} >
                            <Icon
                                alt="alt value"
                                icon="close"
                                size="large"
                                style={{ marginRight: '8px' }}
                            />
                            {t('nonArExtension.cancel')}
                        </button>

                        <Button
                            size="medium"
                            text={t('nonArExtension.revalidate')}
                            variant="primary"
                            disabled={!selectedRows.length || disbaleSubmit}
                            onClick={onClickRevalidate}
                        />

                    </div>
                </div> : null}
                <div className="extension-content-wrapper bulk-revalidation-content-wrapper">
                    <div className="step-one">
                        <div className="search-container">
                            <div className="search-seaction">
                                <h6 className="search-title">{t('nonArExtension.add_users_for_bulk_revalidation')}</h6>
                                <div className="search-subtitle">{t('nonArExtension.non_employee_users')}</div>
                            </div>
                            <div className="search-bar">

                                {/* <Filter
                                    key={selectedFilter ? selectedFilter.id : 'reset'}
                                    className="bulk-filter"
                                    isClearable
                                    label="Select Criteria"
                                    menuPosition="bottom-right"
                                    onChange={(value) => { setSelectedFilter(value) }}
                                    options={[
                                        {
                                            id: '1',
                                            label: 'Expired'
                                        },
                                        {
                                            id: '2',
                                            label: 'Expiring'
                                        }
                                    ]}
                                    selection="single"
                                    size="medium"
                                    style={{}}
                                    showSearch={false}
                                    value={selectedFilter}
                                /> */}
                                <DatePickerInput
                                    className="bulk-date-filter-input"
                                    endYear={2030}
                                    feedbackType={t('nonArExtension.info')}
                                    format="mm/dd/yyyy"
                                    helperText=""
                                    inputSize="medium"
                                    placeholder={t('nonArExtension.expiration_date')}
                                    selected={selectedDate}
                                    setSelected={setSelectedDate}
                                    startYear={1950}
                                    // disabled={selectedFilter ? false : true}
                                    style={{}}
                                />
                                <div className={`${isMobile ? "bulk-mobile-date-btn" : "bulk-desktop-date-btn"}`}>
                                    <div className="d-flex justify-content-end">
                                        <button className={`bulk-date-button ${!selectedDate ? "disabled" : ""} ${direction === t('nonArExtension.before_lower') ? "active" : ""
                                            }`} disabled={!selectedDate} onClick={() => onClickToFilterExpiration(t('nonArExtension.before_lower'))}>
                                            <Icon
                                                alt="alt value"
                                                icon="arrow_back"
                                                size="small"
                                                style={{ marginRight: '8px' }}
                                            />
                                            {t('nonArExtension.before')}
                                        </button>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <button className={`bulk-date-button ${!selectedDate ? "disabled" : ""} ${direction === t('nonArExtension.after_lower') ? "active" : ""
                                            }`} disabled={!selectedDate} onClick={() => onClickToFilterExpiration(t('nonArExtension.after_lower'))}>
                                            {t('nonArExtension.after')}
                                            <Icon
                                                alt="alt value"
                                                icon="arrow_forward"
                                                size="small"
                                                style={{ marginLeft: '8px' }}
                                            />
                                        </button>
                                    </div>
                                    {(selectedFilter || selectedDate) && (
                                        <Icon
                                            alt="alt value"
                                            icon="filter_alt_off"
                                            size="large"
                                            onClick={() => onClickToClearFilters()}
                                            style={{ marginRight: '8px', color: "#005cbc", cursor: "pointer" }}
                                        />
                                    )}
                                </div>

                            </div>

                        </div>
                        {!loading && !error && reactivatedData && reactivatedData.length > 0 ? (
                            <>
                            {/* <div className="top-extension-edit-actions">
                                    <button className="extension-cancel-button ml-0" onClick={onClickCancel} >
                                        <Icon
                                            alt="alt value"
                                            icon="close"
                                            size="medium"
                                            style={{ marginRight: '8px' }}
                                        />
                                        {t('nonArExtension.cancel')}
                                    </button>
                                    <Button
                                        className="ml-3"
                                        size="medium"
                                        text={t('nonArExtension.revalidate')}
                                        variant="primary"
                                        disabled={!selectedRows.length || disbaleSubmit}
                                        onClick={onClickRevalidate}
                                    />
                                </div> */}
                                {selectedRows.length > 0 && (
                                    <div className="bulk-revalidation-selection-info" style={{ padding: '8px 16px', fontSize: '14px' }}>
                                        {`${selectedRows.length} row(s) selected`}
                                    </div>
                                )}
                                <DataTable
                                    key={`${i18n.language}-${currentPageIndex}`}
                                    className="datatable bulk-revalidation-datatable"
                                    columns={columns}
                                    data={currentPageData}
                                    rowKey="gpid"
                                    initialRowSelection={selectedRows.filter(row => {
                                        const gpid = row.original ? row.original.gpid : row.gpid;
                                        return currentPageData.some(d => d.gpid === gpid);
                                    })}
                                    isResizable={false}
                                    enableSorting={false}
                                    onColumnFiltersChange={function oFe() { }}
                                    onGlobalSearchChange={function oFe() { }}
                                    onPageIndexChange={function oFe() { }}
                                    pageIndex={0}
                                    pageSize={pageSize}
                                    totalRowsCount={currentPageData.length}
                                    renderSubComponent={function oFe() { }}
                                    rowExpandingHandler={function oFe() { }}
                                    rowSelectionStateUpdater={(selection) => onRowSelectionChange(selection)}
                                    searchPlaceholder={t('nonArExtension.search_placeholder')}
                                    selection="multiple"
                                    showColumnFilters={false}
                                    showDescription={false}
                                    showFilterButton={false}
                                    showFilterToolbar={false}
                                    showMultiSortMenu={false}
                                    showPagination={false}
                                    showSearchOption={false}
                                    showTableHeader={false}
                                    showTitle={false}
                                    size="large"
                                    sortingHandler={function oFe() { }}
                                    style={{}}
                                    tableDescription="Search for a user using a criteria"
                                    tableHeader="Extension for others"
                                />
                                {/* Pagination */}
                                {totalPages > 1 && (
                                    <div className="datatable-pagination" style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px' }}>
                                        <Pagination
                                            currentPage={currentPageIndex + 1}
                                            pageCount={totalPages}
                                            onUpdate={(newPage) => setCurrentPageIndex(newPage - 1)}
                                            variant="number"
                                            size="medium"
                                        />
                                    </div>
                                )}
                                <div style={{height: "70px"}}/>
                            </>
                        ) : (
                            !loading &&
                            !error && (
                                <div className="error-container">
                                    {error ? <span className="search-subtitle">{error}</span> : renderErrorMesg()}
                                </div>
                            )
                        )}

                    </div>

                </div>
                {showModal && renderConfirmModal()}
                {showWarningModal && renderWarningConfirmModal()}
                <ToastContainer
                    position="bottom-center"
                />
            </div>
        </>

    );


};

export default BulkRevalidation;





